/**
 * Helpers de estado de la solicitud · compartidos por todas las step pages.
 * Antes vivían dentro de `components/solicitudes/solicitud-stepper.tsx`
 * (que sigue re-exportando para compatibilidad) · acá quedan separados de
 * cualquier preocupación de UI para que servicios y hooks los puedan usar.
 */

/**
 * Estados a partir de los cuales la solicitud ya fue enviada a autorización.
 * En estos casos solo los archivos de soporte documental siguen siendo
 * editables · todo lo demás es read-only.
 */
export const ESTADOS_POST_ENVIO = new Set<string>([
  "ListoParaAutorizacion",
  "EnAutorizacionNivel1",
  "EnAutorizacionNivelN",
  "RechazadaParaCorreccion",
  "Autorizada",
  "EnviadaAContabilizacion",
  "DadaDeBajaPorAutorizador",
  "CanceladaPorSolicitante",
  "DescartadaPorPlazoVencido",
  "EnColaContabilizacion",
  "PolizaGenerada",
]);

export function estaPostEnvio(
  estado: string | null | undefined
): boolean {
  return !!estado && ESTADOS_POST_ENVIO.has(estado);
}
